import '../node_modules/bootstrap/dist/js/bootstrap.js';
import './js/grand-menu.js';
// AOS 
import AOS from 'aos';
//import 'aos/dist/aos.css';


// Import Leaflet and MarkerCluster for the display of the interactive map
// To be used in app/content-elements/map.php
import * as L from "leaflet";
import { markerClusterGroup } from 'leaflet.markercluster';
import './js/leaflet-gesture-handling.js'

// Import der Akkordeon-Funktionalität 
import { addAccordionFunctionality } from './js/accordion'

import { addVerticalScrollFunctionality } from './js/vertical-scroll.js';

// Lottie
import lottie from 'lottie-web';
window.lottie = lottie;

// Initialisiere AOS
AOS.init();

import Parallax from 'parallax-js';


// FA 
// // import { library, dom } from '@fortawesome/fontawesome-pro';
// import { triangle } from '@fortawesome/pro-solid-svg-icons';




import * as Sentry from "@sentry/browser";

// Sentry.init({
//     dsn: "https://199b1db7f7f95e8af315d44d8bb4b155@o1134837.ingest.us.sentry.io/4507763994787840",
//     integrations: [
//       Sentry.feedbackIntegration({
//         // Additional SDK configuration goes in here, for example:
//         colorScheme: "system",
//       }),
//     ],
//   });

// const feedback = feedbackIntegration({
//     // Disable injecting the default widget
//     autoInject: false,
// });

// feedback.attachTo(document.querySelector( "#sentry-feedback" ), {
//     formTitle: "Report Issue/Bug!",
// });



// Toggler für Listen- bzw. Blockansicht
function addListToggleFunctionality() {

    const togglers = document.querySelectorAll( '.view-toggler' );
    for ( let i = 0; i < togglers.length; i++ ) {

        togglers[ i ].addEventListener( 'click', e => {

            const target = e.target;

            if ( target.classList.contains( 'active' ) ) return;

            const toggle_type = target.dataset[ 'viewToggle' ];
            const list_toggle_container = target.closest( '.list-toggle-container' );
            const button_container = target.closest( '.button-container' );

            if ( toggle_type === "list" ) {
                list_toggle_container.classList.add( 'display-list' );
            } else {
                list_toggle_container.classList.remove( 'display-list' );
            }

            const sibling_togglers = button_container.querySelectorAll( '.view-toggler' );

            for ( let j = 0; j < sibling_togglers.length; j++ ) {
                if ( sibling_togglers[ j ].dataset[ 'viewToggle' ] === toggle_type ) {
                    sibling_togglers[ j ].classList.add( 'active' );
                } else {
                    sibling_togglers[ j ].classList.remove( 'active' );
                }
            }
        } )
    }
}

// Back to top Scroll Button
function scrollToTopFunctionality() {

    document.getElementById( 'scrollToTop' ).addEventListener( 'click', function( event ) {
        event.preventDefault();
        window.scrollTo( {
            top: 0
            , behavior: 'smooth'
        } );
    } );
}

//Überprüfen, ob nach unten gescrolled wurde - falls ja, Menü hell färben
function addScrollCheck() {
    function checkIfScrolled() {
        if ( window.scrollY > 100 ) {
            document.body.classList.add( 'is-scrolled' )
        } else {
            document.body.classList.remove( 'is-scrolled' )
        }
    }
    document.addEventListener( 'scroll', checkIfScrolled );
    checkIfScrolled();
}


// mobile menu (including accesibility) and language switcher toggler
function addMobileMenuToggle() {
    const skipToMobileMenu = document.querySelector( 'a.skip-link[href="#mobile-menu"]' );
    const menuTogglers = document.querySelectorAll( '.menu-toggler' );
    const mobileMenu = document.querySelector( '#mobile-menu' );
    const mainContent = document.querySelector( 'main' );

    const elementsToHide = [
        document.querySelector( 'header.page-header' )
        , document.querySelector( '.logo-compact' )
        , mainContent
        , document.querySelector( '#site-footer' )
        , document.querySelector( '.mobile-navbar' )
    ];

    function setAriaHiddenForOtherElements( hidden ) {
        elementsToHide.forEach( el => {
            if ( el ) {
                el.setAttribute( 'aria-hidden', hidden ? 'true' : 'false' );
            }
        } );
    }

    if ( skipToMobileMenu && mobileMenu ) {
        skipToMobileMenu.addEventListener( 'click', function( e ) {
            e.preventDefault();

            if ( !mobileMenu.classList.contains( 'is-visible' ) ) {
                mobileMenu.classList.add( 'is-visible' );
                menuTogglers.forEach( toggler => toggler.setAttribute( 'aria-expanded', 'true' ) );
                setAriaHiddenForOtherElements( true );
            }

            const firstFocusable = mobileMenu.querySelector( 'a, button, [tabindex]:not([tabindex="-1"])' );
            if ( firstFocusable ) {
                setTimeout( () => firstFocusable.focus(), 100 );
            }
        } );
    }

    for ( let i = 0; i < menuTogglers.length; i++ ) {
        menuTogglers[ i ].setAttribute( 'aria-controls', 'mobile-menu' );
        menuTogglers[ i ].setAttribute( 'aria-expanded', 'false' );

        menuTogglers[ i ].addEventListener( 'click', () => {
            const isOpen = mobileMenu.classList.toggle( 'is-visible' );
            menuTogglers[ i ].setAttribute( 'aria-expanded', isOpen );
            setAriaHiddenForOtherElements( isOpen );

            if ( isOpen ) {
                const firstFocusable = mobileMenu.querySelector( 'a, button, [tabindex]:not([tabindex="-1"])' );
                if ( firstFocusable ) {
                    setTimeout( () => firstFocusable.focus(), 100 );
                }
            } else {
                menuTogglers[ i ].focus();
            }
        } );
    }

    document.addEventListener( 'keydown', function( e ) {
        if ( e.key === 'Escape' && mobileMenu.classList.contains( 'is-visible' ) ) {
            mobileMenu.classList.remove( 'is-visible' );
            setAriaHiddenForOtherElements( false );
            menuTogglers.forEach( toggler => toggler.setAttribute( 'aria-expanded', 'false' ) );
            if ( menuTogglers.length > 0 ) menuTogglers[ 0 ].focus();
        }
    } );

    const languageToggle = document.querySelector( '#language-toggle' );
    const languageMenu = document.querySelector( '.language-dropdown-menu' );

    if ( languageToggle && languageMenu ) {
        languageToggle.setAttribute( 'aria-expanded', 'false' );
        languageToggle.setAttribute( 'aria-haspopup', 'true' );
        languageToggle.setAttribute( 'aria-controls', 'language-menu' );

        languageToggle.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            const visible = languageMenu.classList.toggle( 'is-visible' );
            languageToggle.setAttribute( 'aria-expanded', visible );
        } );

        document.addEventListener( 'click', ( e ) => {
            const isClickInside = languageMenu.contains( e.target ) || languageToggle.contains( e.target );
            if ( !isClickInside && languageMenu.classList.contains( 'is-visible' ) ) {
                languageMenu.classList.remove( 'is-visible' );
                languageToggle.setAttribute( 'aria-expanded', 'false' );
            }
        } );
    }
}






//For post type pages with a visual: calculate its height and set spacing underneigh accordingly
function calculateVisualSpacing() {

    const visual_text_boxes = document.querySelectorAll( '[data-calculate-visual-height="1"]' );

    for ( let i = 0; i < visual_text_boxes.length; i++ ) {

        const visual_container = visual_text_boxes[ i ];

        if ( window.innerWidth < 768 ) {
            visual_container.querySelector( '.row' ).style.height = 'auto';
            return;
        }

        const textbox_overflow = visual_container.querySelector( '.visual__infobox' ).clientHeight / 2;

        visual_container.querySelector( '.row' ).style.height = textbox_overflow + 'px';
    }
}

//  Scripts initiieren, sobald die Seite vollständig geladen ist.
function pageReadyScripts() {
    addAccordionFunctionality()
    addListToggleFunctionality()
    addVerticalScrollFunctionality()
    scrollToTopFunctionality()
    addScrollCheck()
    addMobileMenuToggle()
    // addSpacerSound()
    calculateVisualSpacing()
    window.addEventListener( 'resize', calculateVisualSpacing )
}
document.addEventListener( 'DOMContentLoaded', pageReadyScripts, false );



// This prevents a finger popup on long press
const no_contextmenu = document.querySelector( '.no-contextmenu' );
if ( no_contextmenu ) {
    no_contextmenu.addEventListener( 'contextmenu', function( e ) {
        e.preventDefault();
    } );
}


// PRELOADER 

// Text nach 2 Sekunden einblenden, unabhängig vom Load Event
var loadingText = document.getElementById( 'loading-text' );
setTimeout( function() {
    loadingText.style.display = 'block';
    loadingText.style.opacity = 1; // Für den Fading-Effekt
}, 1000 ); // Zeigt den Text nach 2 Sekunden an

// Preloader ausblenden, wenn die Seite vollständig geladen ist
window.addEventListener( 'load', function() {
    try {
        var preloader = document.getElementById( 'preloader' );

        if ( preloader ) {
            preloader.classList.add( 'hidden' ); // Fügt die Klasse zum Ausblenden hinzu

            setTimeout( function() {
                preloader.style.display = 'none';
            }, 500 ); // Preloader nach 0.5s Ausblenden
        } else {
            console.warn( 'Preloader-Element nicht gefunden.' );
        }
    } catch ( error ) {
        console.error( 'Fehler beim Ausblenden des Preloaders:', error );

        // Als Sicherheitsmaßnahme: Preloader verstecken, falls etwas schiefgeht
        var preloaderFallback = document.getElementById( 'preloader' );
        if ( preloaderFallback ) {
            preloaderFallback.style.display = 'none'; // Verstecke den Preloader direkt
        }
    }
} );





// Import scripts related to group packages and send enquiry form
import './js/angebotspakete.js';




document.addEventListener( "DOMContentLoaded", function() {
    const elementsToHideForPopup = [
        document.querySelector( 'header.page-header' )
        , document.querySelector( '.logo-compact' )
        , document.querySelector( 'main.page-content' )
        , document.querySelector( '#site-footer' )
        , document.querySelector( '.mobile-navbar' )
    ];

    function setAriaHiddenForPopup( hidden ) {
        elementsToHideForPopup.forEach( el => {
            if ( el ) el.setAttribute( 'aria-hidden', hidden ? 'true' : 'false' );
        } );
    }

    function trapFocus( popup ) {
        const focusableSelectors = 'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])';
        const focusables = popup.querySelectorAll( focusableSelectors );

        if ( focusables.length === 0 ) return;

        let first = focusables[ 0 ];
        let last = focusables[ focusables.length - 1 ];

        // Initialer Fokus
        first.focus();

        function handleKeydown( e ) {
            if ( e.key === 'Escape' ) {
                closePopup( popup );
            }

            if ( e.key === 'Tab' ) {
                if ( focusables.length === 1 ) {
                    e.preventDefault();
                    first.focus();
                    return;
                }

                if ( e.shiftKey && document.activeElement === first ) {
                    e.preventDefault();
                    last.focus();
                } else if ( !e.shiftKey && document.activeElement === last ) {
                    e.preventDefault();
                    first.focus();
                }
            }
        }

        // Bind Listener
        popup.addEventListener( 'keydown', handleKeydown );

        // Beim Schließen wieder entfernen (optional):
        popup.__releaseFocus = () => {
            popup.removeEventListener( 'keydown', handleKeydown );
        };
    }


    function closePopup( popup ) {
        popup.classList.add( 'fade' );
        popup.classList.remove( 'show' );

        setAriaHiddenForPopup( false );

        if ( popup.id === 'infoPopup' ) {
            setCookie( "waldwelt_alert_closed", "true", 3 );
            console.log( "Cookie gesetzt: waldwelt_alert_closed" );
        }

        if ( popup.__opener ) {
            popup.__opener.focus();
        }
    }

    // Allgemeine Popup-Funktionalität
    document.querySelectorAll( '.open-popup' ).forEach( button => {
        button.addEventListener( 'click', function( event ) {
            event.preventDefault();

            let popupId = this.getAttribute( 'data-open-popup' );
            let popup = document.querySelector( '.waldwelt-modal[data-popup-id="' + popupId + '"]' );

            if ( popup ) {
                console.log( "Popup geöffnet: " + popupId );
                popup.__opener = this; // Speichert das auslösende Element
                popup.classList.remove( 'fade' );
                popup.classList.add( 'show' );

                setAriaHiddenForPopup( true );
                trapFocus( popup );
            }
        } );
    } );

    // Popup-Schließen-Buttons und Klick auf Hintergrund
    document.querySelectorAll( '.waldwelt-modal' ).forEach( popup => {
        popup.addEventListener( 'click', function( event ) {
            const isCloseButton = event.target.classList.contains( 'popup-close' ) || event.target.closest( '.popup-close' );
            const innerContent = popup.querySelector( '.card-layout' ) || popup.querySelector( '.modal-content' );
            const isOutsideContent = innerContent ? !innerContent.contains( event.target ) : true;

            if ( isCloseButton || ( event.currentTarget === popup && isOutsideContent ) ) {
                console.log( "Popup wird geschlossen: " + popup.dataset.popupId );
                closePopup( popup );
            }
        } );
    } );

    // Cookie-Funktion: nur für 'infoPopup'
    const infoPopup = document.getElementById( 'infoPopup' );
    if ( infoPopup && !getCookie( "waldwelt_alert_closed" ) ) {
        console.log( "Cookie nicht gefunden, infoPopup wird geöffnet" );
        infoPopup.classList.remove( 'fade' );
        infoPopup.classList.add( 'show' );
        setAriaHiddenForPopup( true );
        trapFocus( infoPopup );
    }

    // Cookie setzen
    function setCookie( name, value, hours ) {
        let date = new Date();
        date.setTime( date.getTime() + ( hours * 60 * 60 * 1000 ) );
        let expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    // Cookie auslesen
    function getCookie( name ) {
        let nameEQ = name + "=";
        let ca = document.cookie.split( ';' );
        for ( let i = 0; i < ca.length; i++ ) {
            let c = ca[ i ].trim();
            if ( c.indexOf( nameEQ ) === 0 ) {
                return c.substring( nameEQ.length, c.length );
            }
        }
        return null;
    }
} );




import './js/angebotspakete-form.js';